import React from "react";
import {buscador} from "../plugins/mapListener";


export default class Success extends React.Component{
    makeInvoicing(evt){
        if (buscador.get("lang").localeCompare("en")==0){
            window.location.href="https://apoyo.savethechildren.mx/invoice"
        }else {
            document.querySelector(".invoicing-container").classList.remove("hidden-alert")
            document.querySelector(".success-container").classList.add("hidden-alert")
            document.getElementById("invoicing_email").value = document.getElementById("email").value
            document.getElementById("invoicing_email").parentElement.classList.add("is-valid")
            document.getElementById("invoicing_email").setAttribute("disabled", "disabled")
            document.querySelector(".send_invoice").setAttribute("disabled", "disabled")
            document.querySelector(".send_invoice").classList.add("disabled")


            fetch("https://api.savethechildrenmx.org/events_api/getRegimen.php", {
                method: 'POST',
                body: ''
            }).then(resp => {
                return resp.text()
            }).then(txt => {
                var data = JSON.parse(txt);
                data.forEach(element => {
                    var option = document.createElement("option")

                    option.value = element.regimen_id
                    option.text = element.nombre

                    document.getElementById("regimen").appendChild(option)
                })

                document.getElementById("regimen").parentElement.classList.add("is-valid")
            })
        }
    }

    generalPublic(evt){
        localStorage.clear();
        window.location.href = "https://apoyo.savethechildren.mx/gracias-cenas";
    }
    render() {
        return (
            <div className={"success-container hidden-alert"} >
                <div className="card">
                    <div className="check">
                        &#10003;
                    </div>
                    <h1 className="legend-14">¡Gracias!</h1>
                    <h2 className="legend-9">Su pago fue exitoso.</h2>
                    <h2  className="legend-10">Le enviaremos un correo electrónico que confirme su pago en breve.</h2>
                    <div className="btn-container">
                        <button className="again legend-11" onClick={this.makeInvoicing}>Deseo generar factura</button>
                        <button className="again legend-12" onClick={this.generalPublic}>No deseo generar factura</button>
                    </div>

                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Success.js